module.exports = __webpack_public_path__ + "static/media/gallery-6.d146ae62.jpg";